import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, XIcon, CheckIcon, LockIcon, ZapIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
const cantAvoid = ['la presión;', 'los pendientes;', 'las conversaciones incómodas;', 'las personas difíciles;', 'los cambios;', 'o los días complicados.'];
const canDo = ['bajar la tensión', 'recuperar el foco', 'poner límites', 'responder con claridad', 'manejar conversaciones difíciles', 'y desconectar cuando el día termina.'];
export function FinalCTA() {
  return <section className="w-full bg-bg-warm py-20 md:py-28 px-4" data-id="element-26" data-mp="vurwivd13lju">
      <div className="max-w-3xl mx-auto" data-id="element-27" data-mp="vu8frhz4737e">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-28" data-mp="qvx3l0lckgm0">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-29" data-mp="2c67pyitc7a5v">
            Tu trabajo ocupa muchas horas de tu vida.
          </h2>
          <p className="font-serif-italic text-rose text-xl md:text-2xl mt-4" data-id="element-30" data-mp="2m19fvgvfsg9i">
            No necesita ocupar también toda tu cabeza.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-5 mb-14" data-id="element-31" data-mp="2v4amdio7s9dp">
          <div className="bg-white border border-line rounded-3xl p-6 md:p-7 shadow-sm" data-id="element-32" data-mp="2v1oe1gti1puf">
            <div className="text-xs font-bold text-muted tracking-widest mb-4" data-id="element-33" data-mp="300ivoffqd8cy">
              NO SIEMPRE PODÉS EVITAR
            </div>
            <ul className="space-y-2.5" data-id="element-34" data-mp="39syd9bn47uxb">
              {cantAvoid.map((c, i) => <li key={i} className="flex items-start gap-3" data-id="element-35" data-mp="3eri33n4txquy" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/10 flex items-center justify-center mt-0.5" data-id="element-36" data-mp="3etco11g3piz1">
                    <XIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-37" data-mp="3iqqrsdl0iyjn" />
                  </span>
                  <span className="text-ink text-sm" data-id="element-38" data-mp="1jlz2y533vnoz">{c}</span>
                </li>)}
            </ul>
          </div>
          <div className="bg-white border border-rose/30 rounded-3xl p-6 md:p-7 shadow-sm" data-id="element-39" data-mp="1sh6pd9qibpqr">
            <div className="text-xs font-bold text-rose tracking-widest mb-4" data-id="element-40" data-mp="1npf0d3n01s2q">
              PERO SÍ PODÉS DESARROLLAR HERRAMIENTAS PARA
            </div>
            <ul className="space-y-2.5" data-id="element-41" data-mp="22d04n0vm1xc8">
              {canDo.map((c, i) => <li key={i} className="flex items-start gap-3" data-id="element-42" data-mp="1xf8as1beo15e" data-mpi={i}>
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-rose/15 flex items-center justify-center mt-0.5" data-id="element-43" data-mp="2bg178rl9p6b5">
                    <CheckIcon className="w-3 h-3 text-rose" strokeWidth={3} data-id="element-44" data-mp="27f8xlx8hgzec" />
                  </span>
                  <span className="text-ink text-sm" data-id="element-45" data-mp="h29rdacchq79">{c}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="text-center font-serif-italic text-rose text-xl md:text-2xl mb-14" data-id="element-46" data-mp="2vyazeordzqq">
          Trabajar mejor también significa aprender a cuidarte mientras
          trabajás.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-rose/30 rounded-3xl p-7 md:p-10 shadow-2xl shadow-rose/10 text-center" data-id="element-47" data-mp="6ze4w39g1lzq">
          <h3 className="font-serif font-bold text-2xl md:text-3xl text-ink uppercase tracking-tight leading-tight" data-id="element-48" data-mp="36dgifl0md4qm">
            Kit Antiestrés para el Trabajo
          </h3>
          <p className="font-serif-italic text-rose text-lg mt-2" data-id="element-49" data-mp="14lbrocuuwdhh">
            4 materiales · +60 páginas prácticas
          </p>
          <div className="text-muted text-[14px] mt-6" data-id="element-50" data-mp="19jdcp3buemvl">
            Valor individual: <span className="line-through" data-id="element-51" data-mp="35nb0cq0aca9i">$39.990</span>
          </div>
          <div className="flex items-baseline justify-center gap-2 flex-wrap mt-1" data-id="element-52" data-mp="35lgnlyz63ogi">
            <span className="font-serif font-bold text-5xl md:text-6xl text-rose" data-id="element-53" data-mp="30p9gw3yy68xi">
              $19.990
            </span>
            <span className="text-lg text-ink-soft" data-id="element-54" data-mp="2rns5v00ecxfo">ARS</span>
          </div>
          <div className="inline-flex items-center gap-2 bg-rose text-white text-xs font-black px-3 py-1 rounded-full mt-3" data-id="element-55" data-mp="2rnib6z4eq23n">
            50% OFF
          </div>
          <div className="text-sm text-muted mt-2 mb-7" data-id="element-56" data-mp="2hwxittfbttt6">
            Pago único · Acceso de por vida
          </div>

          <a href="https://checkout.aula-mater.online/" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (typeof window !== 'undefined' && (window as any).fbq) {
            ;
            (window as any).fbq('track', 'InitiateCheckout');
          }
        }} className="flex items-center justify-center gap-2 w-full bg-rose hover:bg-rose-deep text-white font-bold text-lg md:text-xl py-5 rounded-full text-center shadow-xl shadow-rose/30 hover:-translate-y-0.5 transition-all" data-id="element-57" data-mp="2czni3hmhlvq1">
            <ArrowRightIcon className="w-5 h-5" data-id="element-58" data-mp="nhibxwkc808k" />
            QUIERO ACCEDER AL KIT
          </a>

          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mt-6 text-xs text-muted" data-id="element-59" data-mp="sh3bo97c0cmc">
            <span className="flex items-center gap-1.5" data-id="element-60" data-mp="3rx00senw2b4n">
              <LockIcon className="w-3.5 h-3.5 text-rose" data-id="element-61" data-mp="3vxjwrewq78p7" /> Pago seguro
            </span>
            <span className="text-line" data-id="element-62" data-mp="3vv7hxam9legd">|</span>
            <span className="flex items-center gap-1.5" data-id="element-63" data-mp="4q7k9d6sfjfm">
              <ZapIcon className="w-3.5 h-3.5 text-rose" data-id="element-64" data-mp="9hz474vfuqws" /> Acceso en 5 min
            </span>
            <span className="text-line" data-id="element-65" data-mp="387z9wkxgbran">|</span>
            <span className="flex items-center gap-1.5" data-id="element-66" data-mp="3877p855e7dz5">
              <ShieldCheckIcon className="w-3.5 h-3.5 text-rose" data-id="element-67" data-mp="3d72clypyllfg" /> Garantía 7
              días
            </span>
            <span className="text-line" data-id="element-68" data-mp="kc26hjfn0q6u">|</span>
            <span className="flex items-center gap-1.5" data-id="element-69" data-mp="kar6lupbc2l0">
              <CreditCardIcon className="w-3.5 h-3.5 text-rose" data-id="element-70" data-mp="feai2ze7bm7e" /> Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}